<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="getFilters()"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from "FilterManager";
import AlertServices from "@/services/api/alert.api";
import ReportServices from '@/modules/report/api';
import DocumentServices from '@/modules/report/document';

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Alertas MiPE',
      routes: ["Informes", "Alertas MiPE"]
    },
    model: {
      search: {
        collections: {
          alertsType: [],
          alertsSubType: [],
        },
        filters: {
          alertType: null,
          alertSubType: null,
          sie: null,
        },
      },
    },
  }),
  async mounted() {
    await this.setFilters();
  },
  methods: {
    getFilters() {
      return [
        {
          name: 'alertType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Alerta',
          placeholder: 'Seleccionar',
          class: "col-md-3",
          options: this.model.search.collections.alertsType,
          value: this.model.search.filters.alertType,
          onChanged: this.onChangedAlertType,
        },
        {
          name: 'alertSubType',
          component: 'custom-drop-down',
          fieldKey: 'id', 
          fieldName: 'name',
          label: 'Sub Tipo de Alerta',
          placeholder: 'Seleccionar',
          class: "col-md-3",
          options: this.model.search.collections.alertsSubType,
          value: this.model.search.filters.alertSubType,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          icon: 'fa fa-search orange-icon',
          class: "col-md-auto",
          leftIcon: true,
          value: this.model.search.filters.sie,
          disabled: this.model.search.filters.sieDisabled,
        },
      ]
    },
    async setFilters() {
      await AlertServices.getAlertType()
        .then(res => this.model.search.collections.alertsType = res.data);

      await this.getAlertSubType();
    },
    async onChangedAlertType() {
      this.model.search.filters.alertSubType = null
      this.model.search.collections.alertsSubType = []

      if (!this.model.search.filters.alertType) {
        await this.getAlertSubType();
        return false;
      }

      const params = {
        alertTypeId: this.model.search.filters.alertType.id,
      };

      await this.getAlertSubType(params);
    },
    async getAlertSubType(params) {
      await AlertServices.getAlertSubType(params)
        .then(res => this.model.search.collections.alertsSubType = res.data);
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (isValid) {
        this.process();
      }
    },
    async process() {
      await ReportServices.getReport('studentalerts', {
        alertTypeId: this.model.search.filters.alertType?.id ?? -1,
        alertSubTypeId: this.model.search.filters.alertSubType?.id ?? -1,
        studentSieId: this.model.search.filters?.sie ?? ""
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>

<style>
.date-width-container {
    width: 160px !important;
}
</style>